import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import './notification-slider.css'
import { Dialog } from '@progress/kendo-react-dialogs'
import { Grid } from '@material-ui/core'
import { ButtonHLPure } from '../../pures'

/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const NotificationSliderPure = (props) => {
    // #region variables
    const { t } = useTranslation();
    const { t: tCommon } = useTranslation('common')
    const {
        initializeNotification,
        showNotification,
        toggleNotification,
        playSound,
        toggleSoundActive,
        soundActive,
        socketNotifications,
        helpSection,
        onPinNotification,
        onDisableNotification,
        onAssistChat
    } = props;
    const [scrollY, setScrollY] = useState(60)
    const [notifications, setNotifications] = useState(socketNotifications)
    const sliderRef = useRef(null);
    const [url, setUrl] = useState('')
    const [showModalAttendConversation, setShowModalAttendConversation] = useState(false)
    const [conversationId, setConversationId] = useState('')  
    // #endregion variables

    // #region effects
    useEffect(() => setNotifications(socketNotifications), [socketNotifications])

    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 60) {
                setScrollY(0)
            } else {
                setScrollY(60)
            }
        });
    }, [window.scrollY])

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showNotification])
    // #endregion effects

    // const sendPing = () => {
    //     socketNotifications.emit('ping');
    // }

    // #region methods
    const disableNotification = async (notification) => {
       await onDisableNotification(notification)
    }

    const handleRedirect = (url, notificationType) => {
        //Funcion del primer boton en el Dropdown
        handleNotificationRedirect(url, notificationType)
    };

    const handlePinNotification = async (notification) => {
        await onPinNotification(notification)
    }

    const handleMenuThree = () => {
        //Funcion del tercer boton en el Dropdown
        toggleSoundActive()
    };

    const handleNotificationRedirect = (url, notificationType, conversationId) => {
        if (url === '' || notificationType === process.env.REACT_APP_NOTIFICATION_TYPE_INFO) {
            return null
        } else {
            handleActionByType(url, notificationType, conversationId)
        }
    }

    const handleActionByType = (url, type, conversationId) => {
        console.log(conversationId)
        try {
            switch (type) {
                case 9:
                    setConversationId(conversationId)
                    setUrl(`#/${url}`)
                    setShowModalAttendConversation(true)
                    break;
            }
        } catch (e) {
            console.error(`An error occurred in handleActionByType: ${e?.message}`)
        }
    }

    const handleRedirectToConversation = async () => {
        try {
            if (conversationId) {
                const response = await onAssistChat(conversationId)
                setShowModalAttendConversation(false)
                if (response) {
                    window.location.replace(url)
                }
            }
        } catch (e) {
            console.error(`An error occurred in : ${e.message}`)
        }
    }

    function padTo2Digits(num) {
        return String(num).padStart(2, '0');
    }

    //Funcion para modificar el texto de la hora
    const handleDate = (current) => {
        let date
        const currentDate = new Date(current); // Convert string to Date object
        let halfAnHourAgo = moment().subtract(30, 'minutes').toDate().getTime();
        let oneDayAgo = moment().subtract(1, 'days').toDate().getTime();
        let twoDaysAgo = moment().subtract(2, 'days').toDate().getTime();
        let currentTimestamp = currentDate.getTime();

        if (currentTimestamp > halfAnHourAgo) {
            date = t('notificationSlider.timeNow')
        } else if ((currentTimestamp > oneDayAgo) && (moment(currentDate).isSame(moment(), 'day'))) {
            date = `${t('notificationSlider.timeToday')}  ${padTo2Digits(currentDate.getHours())}:${padTo2Digits(currentDate.getMinutes())}`
        } else if (currentTimestamp > twoDaysAgo && (moment(currentDate).isSame(moment().subtract(1, 'days'), 'day'))) {
            date = `${t('notificationSlider.timeYesterday')}  ${padTo2Digits(currentDate.getHours())}:${padTo2Digits(currentDate.getMinutes())}`
        } else {
            date = `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}   ${padTo2Digits(currentDate.getHours())}:${padTo2Digits(currentDate.getMinutes())}`
        }
        return date
    }

    function handleClickOutside(event) {
        if (
            showNotification && sliderRef.current &&
            !sliderRef.current.contains(event.target) &&
            !event.target.classList.contains('k-avatar-image') &&
            !event.target.classList.contains('icon-notification')
        ) {
            toggleNotification(false)
        }
    }

    const menuNotification = (notification) => {
        let options = [
            <button className={`${notification.route !== '' ? null : 'notification-menu1-none'} `} onClick={(e) => handleRedirect(notification.route, notification.typeNotificationId)}>{t('notificationSlider.menu1')}</button>,
            <button onClick={(e) => handlePinNotification(notification)}>{notification.pinned === 3 ? t('notificationSlider.unpin') : t('notificationSlider.pin')}</button>,
            <div onClick={handleMenuThree}><span>{t('notificationSlider.sound')}</span><input type='checkbox' defaultChecked={soundActive} /></div>
        ]
        if (notification.notificationType === 9) options.splice(0, 1)

        return options
    }
    // #endregion methods

    return (
        <div ref={sliderRef} className={`${initializeNotification ? '' : 'notificationPanel hide'}`}>
            <div style={{ marginTop: scrollY }} className={`notificationPanel ${showNotification ? 'open' : ''}`}>
                {/* Header Verde */}
                <div className='notificationPanel-header'>
                    <p className='notificationPanel-header-title'>
                        {t('notificationSlider.title')}
                    </p>
                </div>

                <div style={{ padding: '6px 12px'}}>
                    {notifications && notifications.length ? notifications.map((notification) => {
                        return (
                            <div className='notification-digital-contract'>
                                <div className='notification-digital-contract-title'>
                                    <div className='notification-title-name cursor-pointer' onClick={(_) => handleNotificationRedirect(notification.route, notification.typeNotificationId, notification.conversationId)}>
                                        <img
                                            src={notification.iconPath}
                                            className='notification-icon-panel'
                                            alt='icono de sección'
                                        />
                                        <span className='notificacion-title-text'>{t(notification.title)}</span>
                                    </div>
                                    <div className='notification-title-icons'>
                                        <img
                                            src={'https://atix-development.s3.us-west-2.amazonaws.com/icons/exit.png'}
                                            className='exit-icon-notification'
                                            alt='icono de sección'
                                            onClick={(e) => disableNotification(notification)}
                                        />
                                        {/* Disabled because is no needed right now */}
                                        {/* <div className='dropdown'>
                                            <Dropdown
                                                trigger={<span className='notification-title-icon1'>...</span>}
                                                menu={menuNotification(notification)}
                                            />
                                        </div> */}
                                    </div>
                                </div>
                                <div onClick={(_) => handleNotificationRedirect(notification.route, notification.typeNotificationId, notification.conversationId)} className='notification-description-box'>
                                    <div className='notification-digital-contract-text'>
                                        <span>{notification.description}</span>
                                    </div>
                                    <div className='notification-digital-contract-time'>
                                        <span>{handleDate(notification.createdDate)}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                        : <div className='notificationPanel-no-notifications'>
                            <p>{t('notificationSlider.noNotifications')}</p>
                        </div>
                    }
                </div>
            </div>
            {
                showModalAttendConversation &&
                <Dialog
                width={400}
                onClose={() => setShowModalAttendConversation(false)}
                title={tCommon('confirm')}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <p>{t('notificationSlider.confirmChat')}</p>
                        </Grid>
                        <Grid item xs={12} className='button-actions'>
                            <ButtonHLPure colorScheme='error' outlined nameBtn={tCommon('cancel')} onClick={() => setShowModalAttendConversation(false)} />
                            <ButtonHLPure primary nameBtn={tCommon('accept')} onClick={handleRedirectToConversation} />
                        </Grid>
                    </Grid>
                </Dialog>
            }
        </div>
    );
};


//Elemento Dropdown para Notificaciones.
export const Dropdown = ({ trigger, menu }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(!open);
    };

    return (
        <div className='dropdown'>
            {React.cloneElement(trigger, {
                onClick: handleOpen,
            })}
            {open ? (
                <ul className='menu'>
                    {menu.map((menuItem, index) => (
                        <li key={index} className='menu-item'>
                            {React.cloneElement(menuItem, {
                                onClick: () => {
                                    menuItem.props.onClick();
                                    setOpen(false);
                                },
                            })}
                        </li>
                    ))}
                </ul>
            ) : null}
        </div>
    );
};
export { NotificationSliderPure as default };
